// Loads public/fonts/hershey-script.json once at application startup and hands
// it to whoever asks. Same preload/get shape as paper-texture.js and
// crowd-atlas.js: handwriting.js reads this through the getter and never fetches
// inside init(), so switching into it never shows an empty page while a font
// downloads.
//
// Built offline by tools/build-hershey.mjs. See that file for the font's own
// licence and the two acknowledgements it requires - which also travel inside
// the JSON, under meta.acknowledgements.
const FONT_URL = 'fonts/hershey-script.json';

let _font = null;
let _promise = null;

export function preloadHersheyFont() {
  if (_promise) return _promise;
  _promise = fetch(FONT_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('hershey-script.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (json) { _font = json; return _font; })
    .catch(function (err) {
      // handwriting.js simply writes nothing with no font, which is the same
      // state a radio stream with no title puts it in - sumi.js still washes.
      console.error('[party-mode] hershey font unavailable, the wash will go unsigned', err);
      _font = null;
      return null;
    });
  return _promise;
}

export function getHersheyFont() {
  return _font;
}

// The SANS face, futural.jhf, built by the same tools/build-hershey.mjs into a
// second JSON. ravesign.js needs a monoline face whose capitals are FRANK and
// wide - a club sign is not written in a cursive hand - and futural is the
// single-stroke sans of the same Hershey distribution, so it carries the same
// licence and the same two acknowledgements (both travel inside the JSON).
//
// futuram.jhf, the "medium" weight, was tried first and rejected: it is a
// DUPLEX face that fakes its weight by drawing every stem as two parallel
// lines, which for a neon tube means every letter becomes two tubes side by
// side. A neon letter is ONE bent tube; the weight comes from the tube's
// radius, not from the font.
const SANS_URL = 'fonts/hershey-sans.json';

let _sans = null;
let _sansPromise = null;

export function preloadHersheySans() {
  if (_sansPromise) return _sansPromise;
  _sansPromise = fetch(SANS_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('hershey-sans.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (json) { _sans = json; return _sans; })
    .catch(function (err) {
      console.error('[party-mode] hershey sans unavailable, the sign will stay dark', err);
      _sans = null;
      return null;
    });
  return _sansPromise;
}

export function getHersheySans() {
  return _sans;
}
